/**
 * A fullscreen component for the gallery and "financial" mode.
 * UPD: now also for the Guide.
 */

import React from "react";
import styled from "styled-components";
import { ScreenSize } from "../../lib/constants";
import { getScreenLayout } from "../../lib/utils";

class PopoverWrapper extends React.Component {
  componentDidMount() {
    // TODO: All the timeout magic here and in the `componentWillUnmount` is related to the cases
    // when we replace one popover with another - new one gets mounted before the previous one
    // gets unmounted. This is probably can be solved using a single Popover instance or Portal.
    setTimeout((_) => {
      window.famHackingScroll = true;
      const body = document.querySelector("body");
      body && body.setAttribute("style", "overflow: hidden;");
    }, 10);
  }

  componentWillUnmount() {
    // TODO: this will fail miserably if initial overflow value was something more custom.
    // Once we discover such case - it will be easy to account for it.
    window.famHackingScroll = false;
    setTimeout((e) => {
      if (window.famHackingScroll) {
        return;
      }
      const body = document.querySelector("body");
      body && body.setAttribute("style", "overflow: auto;");
    }, 20);
  }

  render() {
    const { children, hidden, financialBackground = "", backgroundColor = "white" } = this.props;

    // TODO: check this shit for landscape layout.
    let layoutClass = getScreenLayout();

    if (hidden) {
      layoutClass += " hidden";
    }

    return (
      <PopoverContent
        className={layoutClass}
        hidden={hidden}
        financialBackground={financialBackground}
        backgroundColor={backgroundColor}
      >
        {children}
      </PopoverContent>
    );
  }
}

const PopoverContent = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(props) => props.backgroundColor};
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  display: block;

  font-family: ${(props) => props.theme.fontFamily || "arial"};

  * {
    font-family: ${(props) => props.theme.fontFamily || "arial"};
  }

  &.hidden {
    display: none !important;
  }

  &.desktop {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
  }

  &.portrait {
    overflow: auto;
  }

  &.landscape {
    display: flex;
    flex-direction: column;

    // TODO: refactor this sodomy here.
    > .gallery {
      .image-gallery {
        padding-top: 0;
      }
    }
  }

  .gallery {
    background: white;
    padding: 50px 50px 50px 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    flex: 1;
    max-width: calc(100% - 520px);
    width: auto;

    &.financial {
      padding: 0;
      max-width: 70%;
      background: 100% 100% no-repeat url(${(props) => props.financialBackground});
      background-size: cover;
      color: white;
      text-align: center;
      font-size: 20px;
      .colored-overflow {
        background-color: ${(props) => props.theme.brandColorHalfTransparent};
        position: absolute;
        top: 0;
        left: 0;
        width: 70%;
        height: 100%;

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }

      .financial-logo {
        max-width: 180px;
        padding-bottom: 15px;
      }
    }

    .image-gallery-image {
      max-height: calc(100vh - 200px);
    }

    .image-gallery {
      padding-top: 57px;
    }

    &.mobile {
      max-width: unset;
      width: 100%;
      padding: unset;

      .image-gallery {
        padding-top: 64px;
      }

      .image-gallery-slide > div {
        border-radius: 0;
      }

      .image-gallery-slide {
        .iframe-container {
          height: 50vh;

          iframe {
            height: 100%;
          }
        }
      }
    }

    .image-gallery-slide > div {
      max-height: calc(100vh - 160px);
      overflow: hidden;
      border-radius: 12px;
    }

    .image-gallery-thumbnails .image-gallery-thumbnails-container {
      padding-bottom: 8px;
      cursor: auto;
    }

    .nav-arrow {
      position: absolute;
      right: -50px;

      &.left {
        left: -50px;
      }
    }

    &.landscape {
      max-width: unset;
      padding: 10px 0 0 0;

      .image-gallery-slide {
        width: 70%;
        left: 15%;
        > div {
          max-height: calc(100vh - 85px);
        }
      }

      .image-gallery-image {
        max-height: inherit;
        width: unset;
        border-radius: 12px;
      }
    }
  }

  .right-column {
    width: ${window.innerWidth <= ScreenSize.mobile ? "100%" : "300px"};
    height: 100%;
    padding: 10px 60px;
    box-sizing: border-box;
    display: flex;
    flex: 2;
    justify-content: center;
    flex-direction: column;
    background-color: white;
    max-width: 400px;

    &.financial {
      height: 100%;
      overflow: hidden;
      padding: 0px;
      max-width: none;
      width: 30%;
      flex: none;
    }

    &.mobile {
      padding: 10px 15px;
      max-width: unset;
      display: block;
      height: auto;
    }

    &.landscape {
      height: unset;
      width: 100%;
      max-width: unset;
      padding: unset;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }

  .youtube-iframe,
  .iframe-container iframe {
    // TODO: make youtube player take more space on the screen depending on the screen size.
    //width: calc(100% - 200px);
    //height: calc(100vh - 100px);
    //margin-top: 20px;
  }

  &.portrait {
    .youtube-iframe,
    .iframe-container iframe {
      width: 100%;
      margin-top: 0;
    }
  }
`;

export default PopoverWrapper;
